import React from 'react';
import LocalizedText from '../../../presentational/LocalizedText/LocalizedText';

export interface SurveyNextButtonProps {
    /** Custom label from step definition — overrides all automatic label logic. */
    nextButtonText?: string;
    /** True when this is the last step in the survey (shows "Done"). */
    isLastStep: boolean;
    /** True when this is the last instruction step before real questions begin (shows "Get Started"). */
    isLastInstructionStep?: boolean;
    style?: React.CSSProperties;
    onClick: () => void;
    disabled?: boolean;
}

export default function SurveyNextButton({
    nextButtonText,
    isLastStep,
    isLastInstructionStep,
    style,
    onClick,
    disabled,
}: SurveyNextButtonProps) {
    const label = nextButtonText ? (
        <span>{nextButtonText}</span>
    ) : isLastStep ? (
        <LocalizedText textKey="done-button-text" />
    ) : isLastInstructionStep ? (
        <LocalizedText textKey="get-started-button-text" />
    ) : (
        <LocalizedText textKey="next-button-text" />
    );

    return (
        <button
            className="continue-button"
            data-testid="survey-next-button"
            style={style}
            onClick={onClick}
            disabled={disabled}
        >
            {label}
        </button>
    );
}
